import React, {FC} from 'react';
import {BasketTokenProvider} from './basketStore/BasketTokenProvider';
import {MinimalStateProvider} from './basketStore/useBasketMinimalState';
import {CustomerProvider} from './customer/customer.hooks';
import {SessionProvider} from './sessionStore/session.hooks';
import {UserProvider} from './userStore/user.hooks';
import {WishlistStateProvider} from './wishlistStore/useWishlistState';

export const UserStateProvider: FC<
  React.PropsWithChildren<{
    UserSelectedDiscountProvider: FC<React.PropsWithChildren>;
  }>
> = ({children, UserSelectedDiscountProvider}) => {
  return (
    <SessionProvider>
      <UserProvider>
        <UserSelectedDiscountProvider>
          <WishlistStateProvider>
            <BasketTokenProvider>
              <MinimalStateProvider>
                <CustomerProvider>{children}</CustomerProvider>
              </MinimalStateProvider>
            </BasketTokenProvider>
          </WishlistStateProvider>
        </UserSelectedDiscountProvider>
      </UserProvider>
    </SessionProvider>
  );
};
